export default "__VITE_ASSET__0f1ecf1c__"